import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";
import { SanitizeHTMLString } from "@circle-react/components/shared/uikit/SanitizeContent";
import { Button } from "@circleco/compass/components/Button";

import { UpgradePlanModalBody } from "./UpgradePlanModalBody";
import { UpgradePlanModalFooter } from "./UpgradePlanModalFooter";

interface ErrorDetailsProps {
  buttonLabel: string;
  errorMessage?: string;
  iconColor?: "red" | "grey";
  onClick: () => void;
  title: string;
}

export const ErrorDetails = ({
  title,
  errorMessage,
  buttonLabel,
  onClick,
  iconColor = "red",
}: ErrorDetailsProps) => (
  <>
    <UpgradePlanModalBody>
      <div className="mt-16 text-center">
        <div className="mb-10">
          <Icon type={`68-error-${iconColor}`} size={68} className="!w-16" />
        </div>

        {title && (
          <div className="mb-3">
            <Typography.TitleMd>{title}</Typography.TitleMd>
          </div>
        )}

        {errorMessage && (
          <div className="mb-14">
            <Typography.LabelMd color="text-default">
              <SanitizeHTMLString content={errorMessage} />
            </Typography.LabelMd>
          </div>
        )}
      </div>
    </UpgradePlanModalBody>

    <UpgradePlanModalFooter
      layout="full-width"
      primaryAction={{ label: buttonLabel, onClick }}
    >
      <Button variant="primary" size="lg" fullWidth onClick={onClick}>
        {buttonLabel}
      </Button>
    </UpgradePlanModalFooter>
  </>
);
